module.exports = __webpack_public_path__ + "img/logo_bzb_gray1.svg";